import Vue from "vue";
import { get } from "lodash-es";

export function addComponent(
  parent: any,
  component: any,
  dataFn: (...args: any) => Record<string, unknown>,
  extraProps?: Record<string, unknown>
) {
  const ComponentClass = Vue.extend(component);
  const initData = dataFn() || {};
  const data: Record<string, unknown> = {};
  const propsData: Record<string, unknown> = {};
  const propKeys = Object.keys(get(ComponentClass, "options.props") || {});
  extraProps = extraProps || {};

  Object.keys(initData).forEach((key) => {
    if (propKeys.includes(key)) {
      propsData[key] = initData[key];
    } else {
      data[key] = initData[key];
    }
  });

  const instance = new ComponentClass({
    data,
    propsData,
    ...extraProps,
  });

  instance.$mount(document.createElement("div"));

  const dataSetter = (r: Record<string, unknown>) => {
    Object.keys(r).forEach((key) => {
      instance[key] = r[key];
    });
  };

  const unwatch = parent.$watch(dataFn || {}, dataSetter);

  return {
    instance,
    update: () => dataSetter(dataFn ? dataFn() : {}),
    dispose: () => {
      unwatch();
      instance.$destroy();
    },
  };
}
